export default __webpack_public_path__ + "static/media/alcatraz5.921e0008.jpg";